import { useState, useEffect } from "react";
import { HiOutlineHandThumbUp, HiHandThumbUp } from "react-icons/hi2";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  likePostAction,
  unlikePostAction,
} from "../../redux/actions/postActions";
import { useAuthGate } from "../../contexts/AuthGateContext";

const Like = ({ post }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { openAuthGate } = useAuthGate();
  const { _id, likes } = post;
  const userData = useSelector((state) => state.auth?.userData);

  const [likeState, setLikeState] = useState({
    liked: userData?._id ? post.likes.includes(userData._id) : false,
    localLikes: likes.length,
  });

  useEffect(() => {
    setLikeState({
      liked: userData?._id ? post.likes.includes(userData._id) : false,
      localLikes: post.likes.length,
    });
  }, [post.likes, userData?._id]);

  const toggleLike = async (e) => {
    e.preventDefault();
    
    // Show sign-in modal if user is not logged in
    if (!userData?._id) {
      openAuthGate({ reason: "like", redirectTo: location.pathname });
      return;
    }
    
    const optimisticLikes = likeState.liked
      ? likeState.localLikes - 1
      : likeState.localLikes + 1;

    setLikeState((prevState) => ({
      ...prevState,
      liked: !prevState.liked,
      localLikes: optimisticLikes,
    }));

    try {
      if (likeState.liked) {
        dispatch(unlikePostAction(_id));
      } else {
        dispatch(likePostAction(_id));
      }
    } catch (error) {
      setLikeState((prevState) => ({
        ...prevState,
        liked: !prevState.liked,
        localLikes: optimisticLikes,
      }));
    }
  };

  return (
    <button
      onClick={toggleLike}
      className="flex items-center gap-2 text-gray-600 hover:text-gray-800 transition-colors font-roboto-flex"
    >
      {likeState.liked ? (
        <HiHandThumbUp className="w-5 h-5 text-primary-700" />
      ) : (
        <HiOutlineHandThumbUp className="w-5 h-5" />
      )}
      <span className="text-sm font-roboto-flex">Like</span>
    </button>
  );
};

export default Like;
